import {Component} from '@angular/core';

@Component({
  selector: 'redirect-ico',
  templateUrl: './redirect-ico.component.html'
})
export class RedirectIcoComponent {
}
